import styled from 'styled-components';
import { getTitleStyle } from './bou-title/title-style';

export const NiceTitle = styled.h5`
  ${getTitleStyle({ size: 'h5' })}
`;
